import { useState } from "react";
import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  LayoutDashboard, FileText, GitPullRequest, FolderTree, Image, CalendarDays, Bot, ShieldCheck, BarChart3, Send,
  Handshake, Megaphone, Users, Inbox, Settings, ScrollText, LogOut, Menu, X, ExternalLink, UserCircle, Newspaper, Sparkles, Calculator, Crown, Trash2, Scale, Briefcase, FileSignature, Landmark, BookOpen,
  ChevronDown, Rss, History, Zap,
} from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { BrandIcon, Logo } from "../components/site/Logo";
import { ThemeToggle } from "../components/site/ThemeToggle";

export const NAV = [
  { to: "/admin", label: "Kontrolna ploča", icon: LayoutDashboard, perms: ["dashboard.view"], id: "dashboard", end: true },
  { to: "/admin/articles", label: "Članci", icon: FileText, perms: ["articles.create", "articles.view_all", "articles.factcheck"], id: "articles" },
  { to: "/admin/workflow", label: "Urednički tok", icon: GitPullRequest, perms: ["articles.create", "articles.view_all", "articles.factcheck"], id: "workflow" },
  { to: "/admin/naslovnica", label: "Naslovnica", icon: Newspaper, perms: ["articles.publish"], id: "homepage" },
  { to: "/admin/categories", label: "Kategorije", icon: FolderTree, perms: ["dashboard.view"], id: "categories" },
  { to: "/admin/media", label: "Medijska biblioteka", icon: Image, perms: ["media.upload", "media.manage"], id: "media" },
  { to: "/admin/kalendar", label: "Kalendar objava", icon: CalendarDays, perms: ["articles.create", "articles.view_all"], id: "calendar" },
  { to: "/admin/ai-redakcija", label: "AI redakcija", icon: Bot, perms: ["newsroom.view"], id: "ai-newsroom" },
  { to: "/admin/ai-redakcija/kategorije", label: "AI nacrti po kategorijama", icon: FolderTree, perms: ["newsroom.view"], id: "ai-categories" },
  { to: "/admin/ai-redakcija/pravna-baza", label: "Pravna baza", icon: Scale, perms: ["newsroom.view"], id: "legal-kb" },
  { to: "/admin/lansiranje", label: "Početni sadržaj", icon: Inbox, perms: ["articles.publish"], id: "launch" },
  { to: "/admin/vodici/kvalitet", label: "Kvalitet vodiča", icon: Scale, perms: ["tools.view"], id: "guide-quality" },
  { to: "/admin/ai-redakcija/za-pregled", label: "AI nacrti za pregled", icon: Inbox, perms: ["newsroom.view", "articles.create", "articles.view_all"], id: "ai-inbox" },
  { to: "/admin/balkan-ai", label: "Balkan AI", icon: Sparkles, perms: ["ai.view"], id: "balkan-ai" },
  { to: "/admin/alati", label: "Alati", icon: Calculator, perms: ["tools.view"], id: "tools", end: true },
  { to: "/admin/alati/provjere", label: "Provjere kalkulatora", icon: ShieldCheck, perms: ["tools.view"], id: "tool-checks" },
  { to: "/admin/formulari", label: "Formulari", icon: FileText, perms: ["tools.view"], id: "forms" },
  { to: "/admin/wissenszentrum", label: "Centar znanja", icon: BookOpen, perms: ["tools.view"], id: "knowledge" },
  { to: "/admin/premium", label: "Premium", icon: Crown, perms: ["premium.view"], id: "premium" },
  { to: "/admin/korpa", label: "Korpa", icon: Trash2, perms: ["records.manage"], id: "trash" },
  { to: "/admin/korisnici", label: "Korisnici (čitaoci)", icon: Users, perms: ["readers.view"], id: "readers" },
  { to: "/admin/rechtliches", label: "Pravne stranice", icon: Scale, perms: ["legal.view"], id: "legal" },
  { to: "/admin/datenschutz", label: "Datenschutz centar", icon: ShieldCheck, perms: ["privacy.view"], id: "privacy" },
  { to: "/admin/analitika", label: "Analitika", icon: BarChart3, perms: ["analytics.view", "analytics.own", "analytics.marketing", "analytics.editorial", "analytics.admin", "analytics.reports"], id: "analytics" },
  { to: "/admin/personalizacija", label: "Personalizacija", icon: Sparkles, perms: ["personalization.view"], id: "personalization" },
  { to: "/admin/provjera", label: "Provjera činjenica", icon: ShieldCheck, perms: ["articles.factcheck"], id: "fact-checking" },
  { to: "/admin/distribucija", label: "Distribucija", icon: Send, perms: ["distribution.view"], id: "distribution" },
  { to: "/admin/partneri", label: "Partneri", icon: Handshake, perms: ["partners.view"], id: "partners" },
  { to: "/admin/prodaja", label: "Prodaja", icon: Briefcase, perms: ["sales.view"], id: "sales" },
  { to: "/admin/ponude", label: "Ponude", icon: FileSignature, perms: ["sales.view", "finance.view"], id: "quotes" },
  { to: "/admin/marketing", label: "Marketing", icon: Briefcase, perms: ["sales.view"], id: "marketing" },
  { to: "/admin/komercijala", label: "Komercijala", icon: Briefcase, perms: ["sales.view", "ads.view", "finance.view"], id: "commercial" },
  { to: "/admin/finansije", label: "Finansije", icon: Landmark, perms: ["finance.view"], id: "finance" },
  { to: "/admin/oglasavanje", label: "Oglašavanje", icon: Megaphone, perms: ["ads.view"], id: "advertising" },
  { to: "/admin/users", label: "Korisnici i uloge", icon: Users, perms: ["users.view", "users.manage"], id: "users" },
  { to: "/admin/inquiries", label: "Kontakt upiti", icon: Inbox, perms: ["contact.view"], id: "inquiries" },
  { to: "/admin/ispravke", label: "Registar ispravki", icon: ScrollText, perms: ["corrections.view"], id: "corrections" },
  { to: "/admin/otkazi", label: "Otkazi ugovora", icon: FileSignature, perms: ["cancellations.view"], id: "cancellations" },
  { to: "/admin/settings", label: "Postavke", icon: Settings, perms: ["settings.manage"], id: "settings" },
  { to: "/admin/postavke/footer", label: "Footer stranice", icon: Settings, perms: ["settings.manage"], id: "footer" },
  { to: "/admin/audit", label: "Audit logovi", icon: ScrollText, perms: ["audit.view"], id: "audit" },
  { to: "/admin/email-centrum", label: "E-mail centar", icon: Send, perms: ["email.view"], id: "email-center" },
  { to: "/admin/email-vorlagen", label: "E-mail predlošci", icon: FileText, perms: ["email.view"], id: "email-templates" },
];

const byId = (id) => NAV.find((n) => n.id === id);
const SIMPLE_MAIN = [
  { ...byId("dashboard"), label: "Pregled" }, byId("articles"), { ...byId("ai-inbox"), label: "AI nacrti" }, byId("ai-newsroom"),
  { ...byId("media"), label: "Mediji" }, { ...byId("calendar"), label: "Kalendar" }, { ...byId("inquiries"), label: "Upiti" }, { ...byId("corrections"), label: "Ispravke" }, { ...byId("cancellations"), label: "Otkazi" },
];
const SIMPLE_GROUPS = [
  { id: "advanced", label: "Napredno uredništvo", items: [
    byId("categories"), { to: "/admin/ai-redakcija/izvori", label: "Izvori", icon: Rss, perms: ["newsroom.view"], id: "sources" },
    byId("fact-checking"), byId("workflow"), byId("homepage"), { ...byId("audit"), label: "Historija izmjena", icon: History },
    { ...byId("settings"), label: "Uredničke postavke" }, { ...byId("users"), label: "Uloge i ovlaštenja" },
  ] },
  { id: "ai", label: "AI i izvori", items: ["ai-categories", "legal-kb", "launch", "guide-quality", "balkan-ai", "tools", "tool-checks", "forms", "knowledge"].map(byId) },
  { id: "users-premium", label: "Korisnici i Premium", items: ["readers", "premium", "personalization"].map(byId) },
  { id: "partners-ads", label: "Komercijala", items: ["commercial", "sales", "quotes", "partners", "advertising", "marketing", "finance", "distribution"].map(byId) },
  { id: "modules", label: "Analitika, pravno i korpa", items: ["analytics", "legal", "privacy", "email-center", "email-templates", "footer", "trash"].map(byId) },
];
const linkCls = ({ isActive }) =>
  `flex items-center gap-3 rounded-md px-3 py-2 text-[13.5px] font-medium transition-colors ${isActive ? "bg-white/12 text-white" : "text-white/75 hover:bg-white/5 hover:text-white"}`;

const Group = ({ g, onNav }) => {
  const { can } = useAuth();
  const [open, setOpen] = useState(false);
  const items = g.items.filter((n) => can(...n.perms));
  if (!items.length) return null;
  return (
    <div className="pt-3">
      <button type="button" onClick={() => setOpen(!open)} aria-expanded={open} className="flex w-full items-center justify-between px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-white/45 hover:text-white/80" data-testid={`admin-nav-group-${g.id}`}>
        {g.label} <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="mt-1 space-y-0.5">{items.map((n) => <NavLink key={n.id} to={n.to} end={n.end} onClick={onNav} className={linkCls} data-testid={`admin-sidebar-${n.id}`}><n.icon className="h-4 w-4" /> {n.label}</NavLink>)}</div>}
    </div>
  );
};

const ModeSwitch = () => {
  const { user, setUser } = useAuth();
  const on = !!user?.simple_editorial_mode;
  const flip = async () => {
    try {
      await api.put("/auth/preferences", { simple_editorial_mode: !on });
      setUser({ ...user, simple_editorial_mode: !on });
      toast.success(!on ? "Jednostavni urednički režim uključen" : "Napredni prikaz uključen");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <button type="button" role="switch" aria-checked={on} onClick={flip} className="mx-3 mb-4 flex items-center justify-between gap-3 rounded-lg border border-white/10 px-3 py-2.5 text-left text-[12.5px] text-white/80 hover:bg-white/5" data-testid="simple-mode-toggle">
      <span className="flex items-center gap-2"><Zap className="h-4 w-4 text-pulse" /> Jednostavni urednički režim</span>
      <span className={`relative h-5 w-9 shrink-0 rounded-full transition-colors ${on ? "bg-pulse" : "bg-white/20"}`}><span className={`absolute top-0.5 h-4 w-4 rounded-full bg-white transition-transform ${on ? "translate-x-4" : "translate-x-0.5"}`} /></span>
    </button>
  );
};

const Sidebar = ({ onNav }) => {
  const { can, user } = useAuth();
  const simple = !!user?.simple_editorial_mode;
  return (
    <nav aria-label="Admin navigacija" className="flex h-full flex-col" data-testid="admin-sidebar">
      <Link to="/admin" className="flex items-center gap-3 px-5 py-5" onClick={onNav} data-testid="admin-sidebar-brand">
        <span className="rounded-md bg-white p-1"><BrandIcon className="h-8 w-8" testId="admin-sidebar-icon" /></span>
        <span className="leading-tight"><span className="block font-display text-lg font-semibold text-white">BalkanPuls</span><span className="text-[11px] uppercase tracking-[0.16em] text-white/55">Redakcija</span></span>
      </Link>
      {simple ? (
        <div className="flex-1 space-y-0.5 overflow-y-auto px-3 pb-4" data-testid="admin-sidebar-simple">
          {SIMPLE_MAIN.filter((n) => can(...n.perms)).map((n) => (
            <NavLink key={n.id} to={n.to} end={n.end} onClick={onNav} className={({ isActive }) => `${linkCls({ isActive })} py-2.5 text-[14.5px]`} data-testid={`admin-sidebar-${n.id}`}><n.icon className="h-[18px] w-[18px]" /> {n.label}</NavLink>
          ))}
          {SIMPLE_GROUPS.map((g) => <Group key={g.id} g={g} onNav={onNav} />)}
        </div>
      ) : (
      <div className="flex-1 space-y-0.5 overflow-y-auto px-3 pb-4">
        {NAV.filter((n) => n.soon || can(...n.perms)).map((n) =>
          n.soon ? (
            <NavLink key={n.id} to={`/admin/soon/${n.soon}`} onClick={onNav} className={({ isActive }) => `flex items-center gap-3 rounded-md px-3 py-2 text-[13.5px] ${isActive ? "bg-white/10 text-white/80" : "text-white/40 hover:text-white/60"}`} data-testid={`admin-sidebar-${n.id}`}>
              <n.icon className="h-4 w-4" /> <span className="flex-1">{n.label}</span>
              <span className="rounded bg-white/10 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wider">Uskoro</span>
            </NavLink>
          ) : (
            <NavLink key={n.id} to={n.to} end={n.end} onClick={onNav} className={linkCls} data-testid={`admin-sidebar-${n.id}`}>
              <n.icon className="h-4 w-4" /> {n.label}
            </NavLink>
          ),
        )}
      </div>
      )}
      {can("articles.create", "articles.view_all") && <ModeSwitch />}
    </nav>
  );
};

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const doLogout = async () => {
    await logout();
    nav("/admin/login");
  };
  return (
    <div className="flex min-h-screen bg-background">
      <Helmet><title>Administracija | BalkanPuls.de</title><meta name="robots" content="noindex,nofollow" /></Helmet>
      <aside className="fixed inset-y-0 left-0 z-40 hidden w-64 bg-navy-900 lg:block">
        <Sidebar />
      </aside>
      {open && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setOpen(false)} />
          <aside className="absolute inset-y-0 left-0 w-72 bg-navy-900">
            <button aria-label="Zatvori meni" onClick={() => setOpen(false)} className="absolute right-3 top-5 text-white" data-testid="admin-mobile-close"><X className="h-5 w-5" /></button>
            <Sidebar onNav={() => setOpen(false)} />
          </aside>
        </div>
      )}
      <div className="flex min-w-0 flex-1 flex-col lg:pl-64">
        <header className="sticky top-0 z-30 flex h-16 items-center justify-between gap-3 border-b border-border bg-background/95 px-4 backdrop-blur sm:px-8" data-testid="admin-header">
          <div className="flex items-center gap-3">
            <button aria-label="Otvori meni" onClick={() => setOpen(true)} className="lg:hidden" data-testid="admin-mobile-menu"><Menu className="h-5 w-5" /></button>
            <Logo className="h-8" testId="admin-header-logo" />
            <span className="hidden text-xs font-semibold uppercase tracking-[0.16em] text-muted-foreground md:inline">Urednički CMS</span>
          </div>
          <div className="flex items-center gap-2 sm:gap-4">
            <a href="/" target="_blank" rel="noreferrer" className="hidden items-center gap-1 text-xs font-semibold text-muted-foreground hover:text-foreground sm:inline-flex" data-testid="admin-view-site">Portal <ExternalLink className="h-3 w-3" /></a>
            <ThemeToggle className="hover:bg-muted" />
            <Link to="/admin/profile" className="flex items-center gap-2 text-sm" data-testid="admin-profile-link">
              <UserCircle className="h-5 w-5" />
              <span className="hidden sm:inline"><span className="font-semibold">{user?.name}</span> <span className="text-xs text-muted-foreground">· {user?.roles?.join(", ")}</span></span>
            </Link>
            <button onClick={doLogout} className="inline-flex items-center gap-1 rounded-md px-2 py-1.5 text-sm text-muted-foreground hover:bg-muted hover:text-foreground" data-testid="admin-logout-button">
              <LogOut className="h-4 w-4" /> <span className="hidden sm:inline">Odjava</span>
            </button>
          </div>
        </header>
        <main className="min-w-0 flex-1 px-4 py-8 sm:px-8" data-testid="admin-main"><Outlet /></main>
      </div>
    </div>
  );
}
